import t from '@jetshop/intl';
import React from 'react';
import { useQuery } from 'react-apollo';
import { styled } from 'linaria/react';
import { Container as BaseContainer } from './styledComponents';
import Products from './Products.gql';

import { theme } from '../Theme';
import { ProductCard } from '../CategoryPage/ProductCard';

const Container = styled(BaseContainer)`
  background: transparent;
  padding: 0;

  h2 {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 20px auto 20px auto;
    text-align: center;
    width: 100%;
    display: block;
  }

  .product-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    margin-right: -${theme.space[1]};
    margin-left: -${theme.space[1]};

    .product-card {
      line-height: 19px;
      min-width: 0;

      width: 50%;
      ${theme.above.md} {
        width: 33.333%;
      }
      ${theme.above.lg} {
        width: 20%;
      }
      a {
        margin: 0 0.5em 2em 0.5em;
      }
    }

    .badge-top-right {
      top: 3em;
    }

    width: 100%;
    justify-content: center;
    margin: 0;
    .product-card {
      width: 20%;
    }
    /* Let products overflow on smaller devices */
    ${theme.below.lg} {
      overflow-x: auto;
      display: flex;
      flex-wrap: nowrap;
      .product-card {
        min-width: 65%;
        margin: 0;
      }
    }
    ${theme.below.lg} {
      .product-card {
        min-width: 55vw;
        flex: none;
        a {
          margin-bottom: 0;
        }
      }

      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
      &::-webkit-scrollbar,
      &::-webkit-scrollbar-track,
      ::-webkit-scrollbar-thumb {
        background-color: transparent;
        display: none;
      }
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .product-card {
    font-size: 0.875em;

    header {
      margin-bottom: 0;
    }
  }

  [data-flight-price] {
    display: flex;
  }
  .new-price {
    color: #c7190e;
    margin-right: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .old-price {
    color: ${theme.colors.grey};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: black;
  }
`;

const SingleProduct = ({ articleNumber }) => {
  const result = useQuery(Products, {
    variables: {
      term: articleNumber
    },
    errorPolicy: 'all'
  });
  if (result.loading || result.error) return null;

  if (
    articleNumber ===
    result.data.search.products.result[0].articleNumber.split('_')[0]
  ) {
    return <ProductCard product={result.data.search.products.result[0]} />;
  } else {
    return null;
  }
};

const CustomFieldsProducts = ({ products }) => {
  return (
    <Container>
      <h2>{t('Related products')}</h2>
      <ul className="product-grid">
        {products.map((product, index) => (
          <SingleProduct key={product} articleNumber={product} />
        ))}
      </ul>
    </Container>
  );
};

export default CustomFieldsProducts;
